/**
 * Feed type + connection type, by id.
 *
 * A client-side lookup the API does not expose: `mls_access` and `platform_credential` both
 * carry `feed_type_connection_type_id` and neither response includes the label.
 *
 * The legacy repeated this fourteen-entry list verbatim in five files —
 * `MLSListContainer/AddMlsWizard/AddMlsAccess`, `.../AddAccessModal`,
 * `MLSDetail/MlsAccess/AccessInformation`, and twice inside `Platform/AddPlatform`. It lives
 * here because two features read it (`mls-providers` and `mls-platform`), and a feature may not
 * import another feature (CLAUDE.md > Feature Folder Structure).
 */
export const FEED_CONNECTION_TYPES: Record<number, string> = {
  1: 'IDX/RETS',
  2: 'IDX/RESO_WEB_API',
  3: 'IDX_PLUS/RETS',
  4: 'IDX_PLUS/RESO_WEB_API',
  5: 'VOW/RETS',
  6: 'VOW/RESO_WEB_API',
  7: 'IDX',
  8: 'IDX_PLUS',
  9: 'VOW',
  10: 'RETS',
  11: 'ALL/ALL',
  12: '--/RESO_WEB_API',
  13: 'ALL Feed Type',
  14: 'ALL Connection Type',
};

/** The same list as `{ value, label }` options for a select. */
export const FEED_CONNECTION_OPTIONS = Object.entries(FEED_CONNECTION_TYPES).map(
  ([value, label]) => ({ value, label })
);
